import { useCallback, useState } from 'react';
import { ALL_LOCATIONS_ID } from '../../constants';
import { useQueueAPI } from '../../queue/selectors';
import { useLocationIndexMap, useQueueLocations } from '../../selectors';
import { stripDisplaySuffix } from '../../shrinkage/quickInputDialog';
import { StaffCalculate } from '../types';
export var useCalculatorRoleSync = function (roleNames, watch, setValue) {
    var queueData = useQueueAPI()[0];
    var queueLocations = useQueueLocations();
    var locationIndexMap = useLocationIndexMap();
    var _a = useState(ALL_LOCATIONS_ID), selectedLocationId = _a[0], setSelectedLocationId = _a[1];
    var hasLocations = queueLocations.length > 0;
    var isAllLocations = selectedLocationId === ALL_LOCATIONS_ID;
    var locIdx = locationIndexMap.get(selectedLocationId);
    var roleNameSet = new Set(roleNames.map(function (name) { return name.toLowerCase(); }));
    var getRoleIndex = useCallback(function (locationIdx) {
        var _a, _b, _c, _d, _e, _f;
        return (_f = (_e = (locationIdx === undefined
            ? (_a = queueData.data) === null || _a === void 0 ? void 0 : _a.roles
            : (_d = (_c = (_b = queueData.data) === null || _b === void 0 ? void 0 : _b.queueLocations) === null || _c === void 0 ? void 0 : _c[locationIdx]) === null || _d === void 0 ? void 0 : _d.roles)) === null || _e === void 0 ? void 0 : _e.findIndex(function (r) { return roleNameSet.has(stripDisplaySuffix(r.role).toLowerCase()); })) !== null && _f !== void 0 ? _f : -1;
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [queueData.data]);
    var roleIdx = getRoleIndex(locIdx);
    var watchPath = hasLocations && locIdx !== undefined
        ? "queueLocations.".concat(locIdx, ".roles.").concat(roleIdx, ".staffCalculate")
        : "roles.".concat(roleIdx, ".staffCalculate");
    var isFTEBased = watch(watchPath) === StaffCalculate.FTE;
    var applyRatioToRoles = useCallback(function (ratio) {
        var update = function (locationIdx) {
            var rIdx = getRoleIndex(locationIdx);
            if (rIdx < 0)
                return;
            var path = locationIdx === undefined ? "roles.".concat(rIdx, ".ratio") : "queueLocations.".concat(locationIdx, ".roles.").concat(rIdx, ".ratio");
            setValue(path, ratio, { shouldDirty: true });
        };
        if (!hasLocations) {
            update();
        }
        else if (isAllLocations) {
            for (var _i = 0, _a = queueLocations.map(function (_, idx) { return idx; }); _i < _a.length; _i++) {
                var index = _a[_i];
                update(index);
            }
        }
        else if (locIdx !== undefined) {
            update(locIdx);
        }
    }, [getRoleIndex, hasLocations, isAllLocations, locIdx, queueLocations, setValue]);
    return {
        isFTEBased: isFTEBased,
        selectedLocationId: selectedLocationId,
        setSelectedLocationId: setSelectedLocationId,
        applyRatioToRoles: applyRatioToRoles,
    };
};
